import React from 'react'

const UserBoardActivityAndStreakLoader = () => (
  <div className="loader user-block-loader">
    <div className="user-block-loader__left">
      <div className="user-block-loader__avatar" />
      <div className="user-block-loader__activity">
        <div
          className="loader-row"
          style={{
            width: 34,
            height: 28,
          }}
        />
        <div
          className="loader-row"
          style={{
            width: 67,
            height: 15,
            marginTop: 9,
          }}
        />
        <div
          className="loader-row"
          style={{
            width: 77,
            height: 15,
            marginTop: 4,
          }}
        />
      </div>
    </div>
    <div className="user-block-loader__right">
      <div className="user-block-loader__fire" />
      <div className="user-block-loader__streak">
        <div
          className="loader-row"
          style={{
            width: 34,
            height: 28,
          }}
        />
        <div
          className="loader-row"
          style={{
            height: 15,
            width: 67,
            marginTop: 9,
          }}
        />
      </div>
    </div>
  </div>
)

UserBoardActivityAndStreakLoader.displayName = 'UserBoardActivityAndStreakLoader'

export default UserBoardActivityAndStreakLoader
